// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Anmol Rajpal <anmol@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import es from './locales/es.json'
import hi from './locales/hi.json'

const LANG_KEY = 'console_lang'
const RTL_LANGS = new Set<string>()

const stored = sessionStorage.getItem(LANG_KEY) ?? 'en'

void i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      hi: { translation: hi },
    },
    lng: stored,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
  })

export { i18n, LANG_KEY, RTL_LANGS }
